<template>
                <div id="vue-tables-options" class="container">
                  <v-client-table 
                    class="hydroware-table"
                    :data="myController.incidents" 
                    :columns="myController.compliance_columns" 
                    :options="myController.optionstable">  
                    <!--FG - FOOF - After Cert - First Release (7) - First Release Security
                    The v-if - added the call to $hydrowareSecurityJS.canAdd-->
                    <hydroware-add-button
                      v-if="$hydrowareSecurityJS.canAdd_A('incidents')"
                      slot="afterLimit" 
                      @click="myController.addCompliancevit()"
                      v-show="!myController.isediting">
                    </hydroware-add-button>
                    <template slot="IncidentDate" slot-scope="props">
                      {{props.row.IncidentDate | fdate}}
                    </template>
                    <template slot="Actions" slot-scope="props">
                      <div>

<!--
                          FG - FOOF - After Cert - First Release (7) - First Release Security - BELOW
                          Show either the view button or the edit button based upon level of access                    
                        -->
                        <hydroware-viewOrEdit-button
                          :EV="$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('incidents')"
                          @click="myController.editcol(props)" 
                        /> 
                        <!--FG - FOOF- After Cert - First Release (7) - First Release Security - Test to see if delete btn should display -->
                        <hydroware-delete-button 
                          v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                          @click="myController.del(props)"
                        />
                        <!--
                        <hydroware-edit-button @click="myController.editcol(props)" />
                        <hydroware-delete-button @click="myController.del(props)" />
                        -->
                      </div>
                    </template>
                  </v-client-table>
                </div>
            </template>
<script>
export default {
    props: ['myController']
  }
</script> 


// WEBPACK FOOTER //
// incidentAndAccidentTable.vue?7b756572